import cancellationPortal from '@cancellation-portal/internationalization/localization-messages/CancellationPortal/en-US.json';
import cancellationPortalAgencyAgreement from '@cancellation-portal/internationalization/localization-messages/cancellations/cancellation-portal/cancellation-portal-agency-agreement/en-US.json';

export const enUSTranslations = {
  CancellationPortal: cancellationPortal,
  'cancellations/cancellation-portal/cancellation-portal-agency-agreement': cancellationPortalAgencyAgreement,
};
